import { BaseButton } from 'app/components/buttons/BaseButton';
import { AddIcon } from 'app/components/icons';
import { ActionsListItem, Menu } from 'app/components/menu';
import clsx from 'clsx';
import React, { useCallback, useMemo, useState } from 'react';
import './Fab.less';

interface Props {
  actions: ActionsListItem[];
  buttonClassName?: string;
  menuClassName?: string;
}

export default function Fab({
  actions,
  buttonClassName,
  menuClassName,
}: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined);

  const handleMenuOpen = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      const element = event.currentTarget;
      setAnchorEl(prevAnchorEl => (prevAnchorEl ? undefined : element));
    },
    [],
  );

  const hasActiveActions = useMemo(
    () => actions.some(({ exclude }) => !exclude),
    [actions],
  );

  if (!hasActiveActions) {
    return null;
  }

  return (
    <>
      <BaseButton
        className={clsx(
          'fab',
          {
            fab_open: anchorEl,
          },
          buttonClassName,
        )}
        onClick={handleMenuOpen}
      >
        <AddIcon />
      </BaseButton>

      <Menu
        menuClassName={menuClassName}
        anchorEl={anchorEl}
        actions={actions}
        onClose={() => setAnchorEl(undefined)}
      />
    </>
  );
}
